//
// PageBase
//
import { mapMutations } from 'vuex'
import PartBase from './PartBase'
import AppPage from '@/pages/App/AppPage'

export default function PageBase (title) {
  return {
    mixins: [
      PartBase
    ],
    components: {
      AppPage
    },
    metaInfo () {
      return {
        title: this.pageTitle
      }
    },
    data () {
      return {
        pageTitle: title,
        fetcher: []
      }
    },
    async created () {
      this.stateInit()
    },
    async mounted () {
      if (await this.fetchPageData(true)) {
        this.stateReady()
      }
    },
    watch: {
      $route () {
        this.fetchPageData(false)
      }
    },
    methods: {
      ...mapMutations([
        'stateInit',
        'stateReady',
        'stateWaits'
      ]),

      // fetch 関数を追加する
      addFetcher (fn) {
        this.fetcher.push(fn)
      },

      // 登録されている fetch 関数を順次実行する
      async fetchPageData (enter) {
        try {
          for (let i = 0, len = this.fetcher.length; i < len; ++i) {
            if (!await this.fetcher[i](enter)) {
              return false
            }
          }
        } catch (err) {
          console.error(err)

          this.stateAddErrors([
            '予期しないエラーが発生しました。',
            err.toString()
          ])
          return false
        }
        return true
      }
    }
  }
}
